import { ReactElement } from 'react';
import {
  montefioreUtilityLeftMenu,
  montefioreUtilityRightMenu,
  flyoutMenu,
  flyoutHeadline,
} from './header-data';
import { HeaderMainMenu } from './header-main-menu';
import { HeaderSecondaryMenu } from './header-secondary-menu';
import { HeaderUtilityMenu } from './header-utility-menu';

import '../montefiore.css';

export const MontefioreHeader = (): ReactElement => (
  <div
    id={'block-navigation'}
    className={'block-meda-blocks block-navigation block print:hidden'}
  >
    <header className={'mf-navigation'}>
      <div className={'relative z-10'}>
        <div
          className={'mf-top-bar mf-top-bar--site-montefiore'}
          data-analytics-event={'e_navigationClick'}
          data-analytics-navigation-type={'top-bar'}
        >
          <HeaderUtilityMenu
            leftLinks={montefioreUtilityLeftMenu}
            rightLinks={montefioreUtilityRightMenu}
          />
          <HeaderMainMenu />
        </div>
        <HeaderSecondaryMenu
          headline={flyoutHeadline}
          flyoutMenu={flyoutMenu}
        />
      </div>
    </header>
  </div>
);
